import { CommonModule } from '@angular/common';
import { Component, effect, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  MapMarker,
  MarkerService,
} from 'src/app/overall-network-status/lib/types';

import { getStatusColor } from '../../../../lib/functions';
import { LeafletXContent } from '../shared/leaflet-x-content.component';

@Component({
  selector: 'app-leaflet-popup-content',
  standalone: true,
  styleUrls: ['../shared/leaflet-x-content.component.scss'],
  imports: [CommonModule, MatTooltipModule],
  template: `
    <div class="dropdown">
      <div class="dropdown-content">
        <div class="table-container">
          <div
            class="flex items-center justify-start overflow-x-auto bg-gray-100"
          >
            @for (service of mapMarker()?.services || []; track service.name) {
              <button
                (click)="selectedService = service"
                class="flex items-center gap-1 rounded-t-md px-2 py-1 font-semibold transition-all duration-100 hover:bg-gray-50"
                [ngClass]="[
                  selectedService?.name === service.name
                    ? 'bg-white'
                    : 'bg-transparent',
                ]"
              >
                {{ service.name }}
              </button>
            }
          </div>
          <table>
            <tbody>
              @if (selectedService; as service) {
                <tr>
                  <td data-label="Record Type">
                    <span matTooltip="Record Type">
                      {{ service.recordType }}
                    </span>
                  </td>
                  <td data-label="Source">
                    <span matTooltip="Source">
                      {{ service.source }}
                    </span>
                  </td>
                  <td data-label="Status">
                    <div
                      class="flex items-center overflow-hidden text-ellipsis whitespace-nowrap"
                      matTooltip="Status"
                    >
                      <svg width="22" height="22" style="margin-right: 5px;">
                        <circle
                          r="10"
                          cx="50%"
                          cy="50%"
                          stroke="black"
                          stroke-width="1"
                          [attr.fill]="serviceStatusColor(service.status)"
                        ></circle>
                      </svg>
                      {{ service.status }}
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div class="table-container">
          <div class="table-v-scroll">
            <table>
              <thead>
                <tr>
                  <th>Element</th>
                  <th>Record Type</th>
                  <th>Vendor</th>
                  <th>Vendor Circuit Id</th>
                </tr>
              </thead>
              <tbody>
                @if (selectedService; as service) {
                  @for (element of service.elements || []; track element.name) {
                    <tr>
                      <td data-label="Element">
                        <span>{{ element.name }}</span>
                      </td>
                      <td data-label="Record Type">
                        <span>{{ element.recordType?.name || '' }}</span>
                      </td>
                      <td data-label="Vendor">
                        <span>{{ element.vendor?.name || '' }}</span>
                      </td>
                      <td data-label="Vendor Circuit Id">
                        <span>{{ element.vendor?.circuitId || '' }}</span>
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class LeafletPopupContentComponent implements LeafletXContent {
  readonly mapMarker = input<MapMarker>();

  readonly serviceStatusColor = getStatusColor;

  selectedService: MarkerService | null = null;

  constructor() {
    effect(() => {
      const value = this.mapMarker();
      if (value) {
        this.selectedService = value.services[0] || null;
      }
    });
  }
}
